// From the Auth0 React Library
const CODE_RE = /[?&]code=[^&]+/
const STATE_RE = /[?&]state=[^&]+/
const ERROR_RE = /[?&]error=[^&]+/

export const hasLoginAuthParams = (
  searchParams = window.location.search
): boolean =>
  (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) &&
  STATE_RE.test(searchParams)

// Matches the home page ("/home" or "/forecast/home", with or without a
// trailing slash / site segment) regardless of the base path it's mounted under.
const HOME_PATH_RE = /\/home(\/|$)/

/**
 * Pulls the `redesign` param off the current Cantilever URL so it can be
 * forwarded to Auth0's `/authorize` call as an extra param. Custom keys on
 * `authorizationParams` are passed straight through to the hosted login page,
 * where they surface as `config.extraParams.redesign` for the redesigned UI to
 * read.
 *
 * When an unauthenticated user lands on the home page we default `redesign=1`
 * so the hosted login page shows the redesigned UI without needing an extra
 * redirect hop to stamp the param onto the URL first. An explicit `redesign`
 * param in the URL always wins. Returns an empty object otherwise so we never
 * send a blank value.
 */
export const redesignAuthorizationParams = (
  searchParams = window.location.search,
  pathname = window.location.pathname
): { redesign?: string } => {
  const redesign = new URLSearchParams(searchParams).get('redesign')
  if (redesign !== null) return { redesign }
  if (HOME_PATH_RE.test(pathname)) return { redesign: '1' }
  return {}
}

// TODO: Done in keycloak, but not in Auth0 or Cognito. We should use this in
// all vendors to reduce rerenders
export class AuthState {
  authorization: string = ''
  tokenExpiration: Date = new Date()
}
